<template>
  <div>
    <MenuStorage/>
    <Return_stock/>
  </div>
</template>

<script>
import MenuStorage from "@/components/admin/stock/menustorage/MenuStorage.vue";
import Return_stock from "@/components/admin/stock/storage_return/Return_stock.vue";
export default {
  name: "ReturnStorage",
  components: {
    Return_stock,
    MenuStorage
  }
}
</script>

<style scoped>

</style>
